import {
  COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_FORLIKSRAD,
  COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_NAMSMANN,
  courtTypeIds,
} from "us.common/constants";

/**
 * @description - get Excel Data By Import Type
 * @param type - import type
 * @param courtTypeId - selected courtTypeId
 * @returns - return header array
 */
export const getExcelDataByImportType = (courtTypeId?: number): Array<any> => {
  switch (courtTypeId) {
    case courtTypeIds.FORLIKSRAD:
      return [COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_FORLIKSRAD];
    case courtTypeIds.NAMSMANN:
      return [COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_NAMSMANN];
    default:
      return [];
  }
};

/**
 * @description - Convert array to string
 * @param array - records
 * @returns - returns comma separated string
 */
const arrayToCSV = (array: Array<any>, separator: "," | ";"): string => {
  try {
    const rows = array.map((row) => row.join(separator));
    return rows.join("\n");
  } catch (e) {
    return "";
  }
};

/**
 * @description - Download csv file from an array
 * @param columns - List of column names
 * @param filename - File name for the csv file
 */
export const downloadCSV = (
  columns: Array<any>,
  filename: string,
  separator: "," | ";" = ","
) => {
  try {
    const csvData = arrayToCSV(columns, separator);
    const blob = new Blob([csvData], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    console.error("Error downloading the file");
  }
};
